import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Mental from "../Forms/F/Mental/Mental"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const MentalContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingMental, setIsGettingMental] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingMental(true)
      handleSubmitGet(endpoints.GET_MENTAL_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.MENTAL,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.MENTAL)
          handleLoadPrev(false)
          setIsGettingMental(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingMental(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_f_1: data?.form?.gpraF1 ?? "",
      gpra_f_2a: data?.form?.gpraF2a,
      gpra_f_2a_num: data?.form?.gpraF2aNum ?? 0,
      gpra_f_2b: data?.form?.gpraF2b,
      gpra_f_2b_num: data?.form?.gpraF2bNum ?? 0,
      gpra_f_2c: data?.form?.gpraF2c,
      gpra_f_2c_num: data?.form?.gpraF2cNum ?? 0,
      gpra_f_2d: data?.form?.gpraF2d,
      gpra_f_2d_num: data?.form?.gpraF2dNum ?? 0,
      gpra_f_2e: data?.form?.gpraF2e,
      gpra_f_2e_num: data?.form?.gpraF2eNum ?? 0,
      gpra_f_2f: data?.form?.gpraF2f,
      gpra_f_2f_num: data?.form?.gpraF2fNum ?? 0,
      gpra_f_2g: data?.form?.gpraF2g,
      gpra_f_2g_num: data?.form?.gpraF2gNum ?? 0,
      gpra_f_3: data?.form?.gpraF3 ?? "",
      gpra_f_4: loadMedicalCare(data?.form),
      gpra_f_4f_a: data?.form?.gpraF4f_a ?? "",
      gpra_f_5: data?.form?.gpraF5 ?? "",
      gpra_f_5a: data?.form?.gpraF5a ?? "",
      gpra_f_5a_a: data?.form?.gpraF5a_a ?? "",
      gpra_f_id: data?.form?.gpraFId ?? 0,
      additional: data?.additional,
    }
  }
  const loadMedicalCare = (data) => {
    let medicalCare = []
    data?.gpraF4a && medicalCare.push(data?.gpraF4a)
    data?.gpraF4b && medicalCare.push(data?.gpraF4b)
    data?.gpraF4c && medicalCare.push(data?.gpraF4c)
    data?.gpraF4d && medicalCare.push(data?.gpraF4d)
    data?.gpraF4e && medicalCare.push(data?.gpraF4e)
    data?.gpraF4f && medicalCare.push(data?.gpraF4f)
    return medicalCare
  }
  if (isGettingMental) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingMental && (
        <Mental showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default MentalContainer
